<script>
/**
 * @overview 课时详情 - 素材弹窗
 *
 * @author jiangzhijie
 */

import mapUtils, { $http } from "@/utils";

export default {
    name: "CourseDetailReview",

    props: {
        id: {
            type: String,
            required: true,
        },
    },

    data: () => ({
        loading: {
            init: false,
            fetch: false,
            submit: false,
        },

        list: {
            data: [],
        },

        review: "",

        query: {
            page: 1,

            per_page: 10,

            "like[name]": "",

            "equal[type]": null,
        },
    }),

    computed: {
        types() {
            const type = JSON.parse(JSON.stringify(this.$store.state.material.types));
            const data = [];
            switch (this.id) {
                case "file":
                    for (const i in type) {
                        if (type[i].value === 41 || type[i].value === 51) {
                            data.push(type[i]);
                        }
                    }
                    break;
                case "video":
                    for (const i in type) {
                        if (type[i].value === 3 || type[i].value === 61) {
                            data.push(type[i]);
                        }
                    }
            }
            return data;
        },
    },

    created() {
        this.query["equal[type]"] = this.types[0].value;

        this.gameFetchList();
    },

    methods: {
        ...mapUtils("list", ["fetch", "routeQuery"]),

        ...mapUtils("form", ["submit", "errorAlert"]),


        reviewCheckin(file) {
            this.review = file.preview_url;
        },

        gameFetchList() {
            this.loading.fetch = true;

            const query = this.$list_routeQuery(this.query, {});

            return this.$list_fetch("/resource", query)
                .then((res) => {
                    this.list = res;
                })
                .finally(() => {
                    this.loading.fetch = false;
                });
        },

        queryPage(value) {
            this.query.page = value;

            this.gameFetchList();
        },

        queryType(value) {
            this.query["equal[type]"] = value;

            this.gameFetchList();
        },

        queryName(nameQuery) {
            this.query = { ...this.query, ...nameQuery, page: 1 };

            this.gameFetchList();
        },

        submit() {
            const file = this.review;
            if (file.length <= 0) {
                this.$alert("请选择文件！");
            } else {
                this.loading.submit = true;
                this.$emit("success", file, this.id);
            }
        },

        cancel() {
            this.$emit("cancel");
        },
    },
};
</script>

<template>
  <div
    v-loading="loading.fetch || loading.init"
    class="course-detail-review"
  >
    <div class="course-detail-review__header">
      <v-radio-text
        :value="query['equal[type]']"
        :list="types"
        label-key="name"
        @change="queryType"
      />

      <AppQueryName
        :value.sync="query['like[name]']"
        @query="queryName"
      />
    </div>

    <div class="course-detail-review__body">

      <el-table
        :data="list.data"
        highlight-current-row
        class="course-detail-review__table"
        @current-change="reviewCheckin"
      >
        <el-table-column
          :index="index => index + 1"
          align="center"
          width="100px"
          type="index"
          label="序号"
        />

        <el-table-column
          label="名称"
          prop="name"
        />

        <el-table-column
          label="制作日期"
          prop="created_at"
        />

        <el-table-column
          align="center"
          width="100px"
          label="操作"
        />
      </el-table>
    </div>

    <AppPagination
      :list="list"
      :size="query.per_page"
      @changeIndex="queryPage"
    />

    <AppFormSubmit
      :submitting="loading.submit"
      @submit="submit"
      @cancel="cancel"
    />
  </div>
</template>

<style lang="postcss">
.course-detail-review {
    flex-direction: column;
    display: flex;
    /*height: 700px;*/
    height: auto;
}

.course-detail-review__header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid var(--bd-color-default);
    padding-bottom: 1.5em;
    margin-bottom: 1.5em;
}

.course-detail-review__header .el-input-group {
    width: auto;
}

.course-detail-review__body {
    display: flex;
    flex: auto;
}

.course-detail-review__value {
    flex: none;
    display: flex;
    flex-direction: column;
    width: 260px;
    padding-right: 1em;
    margin-right: 1em;
    border-right: 1px solid var(--bd-color-default);
}

.course-detail-review__value > :not(:last-child) {
    margin-bottom: 6px;
}

.course-detail-review__value .el-tag {
    display: flex;
    align-items: center;
}

.course-detail-review__value .el-tag__close {
    margin-left: auto;
    margin-bottom: -2px;
    padding-top: 1px;
}

.course-detail-review__table {
    flex: auto;
}

/* 取出el-table append时的下边 */
.course-detail-review__table.el-table::before {
    background-color: transparent;
}
</style>
